function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M30.87 81.754l4.221-33.374L.048 65.506 30.87 81.754z",
  fill: "currentColor",
  fillRule: "nonzero"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M81.15 21.276c9.875 19.167 2.385 42.812-16.753 52.791l-5.091-9.765c13.812-7.201 19.152-24.283 11.989-38.11-7.201-13.812-24.297-19.191-38.11-11.99-13.812 7.202-19.199 24.337-11.99 38.111a28.109 28.109 0 006.787 8.504l-7.112 8.406a39.04 39.04 0 01-9.439-11.82C1.437 38.194 8.898 14.446 28.094 4.438 47.291-5.571 71.051 1.905 81.06 21.101l.09.175",
  fill: "currentColor",
  fillRule: "nonzero"
});

function SvgReplay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 86 82",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgODYgODIiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS1taXRlcmxpbWl0PSIyIj4KICA8cGF0aCBkPSJNMzAuODcgODEuNzU0bDQuMjIxLTMzLjM3NEwuMDQ4IDY1LjUwNiAzMC44NyA4MS43NTR6IiBmaWxsPSJjdXJyZW50Q29sb3IiIGZpbGwtcnVsZT0ibm9uemVybyIvPgogIDxwYXRoIGQ9Ik04MS4xNSAyMS4yNzZjOS44NzUgMTkuMTY3IDIuMzg1IDQyLjgxMi0xNi43NTMgNTIuNzkxbC01LjA5MS05Ljc2NWMxMy44MTItNy4yMDEgMTkuMTUyLTI0LjI4MyAxMS45ODktMzguMTEtNy4yMDEtMTMuODEyLTI0LjI5Ny0xOS4xOTEtMzguMTEtMTEuOTktMTMuODEyIDcuMjAyLTE5LjE5OSAyNC4zMzctMTEuOTkgMzguMTExYTI4LjEwOSAyOC4xMDkgMCAwMDYuNzg3IDguNTA0bC03LjExMiA4LjQwNmEzOS4wNCAzOS4wNCAwIDAxLTkuNDM5LTExLjgyQzEuNDM3IDM4LjE5NCA4Ljg5OCAxNC40NDYgMjguMDk0IDQuNDM4IDQ3LjI5MS01LjU3MSA3MS4wNTEgMS45MDUgODEuMDYgMjEuMTAxbC4wOS4xNzUiIGZpbGw9ImN1cnJlbnRDb2xvciIgZmlsbC1ydWxlPSJub256ZXJvIi8+Cjwvc3ZnPg==";
export { SvgReplay as ReactComponent };